import React from 'react';
import { Box, HStack, Text } from '@chakra-ui/react';

import { ScannerMode } from '../../../../../../RelevoAssignment/model/enums/scanner-mode.enum';
import { useDepositSuccessResult } from '../../../../hooks/use-deposit-success-result.hook';

export const ExpiryDaysInfo = () => {
  const { mode, expiryDays, translations, expiryDaysText } = useDepositSuccessResult();

  if (!(mode === ScannerMode.DEPOSIT_ASSIGN && expiryDays)) {
    return null;
  }

  return (
    <HStack w="100%" spacing="auto" pt={2}>
      <Box w="50%" fontWeight={'bold'}>
        {translations('deposit_expiry_days')}
      </Box>
      <Box w="50%">
        <Text>{expiryDaysText}</Text>
      </Box>
    </HStack>
  );
};
